import { createFileRoute } from '@tanstack/react-router'
import { SmartSpacePage } from '@/features/smartspace/pages/SmartSpacePage'

export const Route = createFileRoute('/_app/smartspace/')({
  component: SmartSpacePage,
})
